<template>
  <div class="w-11/12 mx-auto flex-row flex-wrap justify-between font-costea">

    <!-- <div v-if="loading" class="flex justify-center items-center h-screen">
      <div class="loader text-2xl font-bold"></div>
    </div> -->

    <div class="w-full pt-3 pb-2 mb-6 mt-2 border-b-2">
  <!-- Título siempre visible -->
  <h1 class="font-costea text-h24 font-medium text-costeaBlack mb-4">
    Productos
  </h1>

  <!-- Layout Mobile (sm) -->
  <div class="md:hidden flex flex-col gap-4">
    <!-- Fila 1: Selects "Ordenar por" y "Nombre/Referencia" -->
    <div class="flex flex-row gap-2">
      <!-- Select "Ordenar por" -->
      <select
        v-model="filtroOrden"
        class="flex-1 min-w-[100px] text-costeaGray py-1 h-10 box-border rounded-md text-t14"
      >
        <option value="0">Ordenar por:</option>
        <option value="1">P. venta de menor a mayor</option>
        <option value="2">P. venta de mayor a menor</option>
        <option value="3">Costo de menor a mayor</option>
        <option value="4">Costo de mayor a menor</option>
      </select>

      <!-- Select "Nombre/Referencia" -->
      <select
        v-model="typeSearch"
        class="flex-1 min-w-[100px] text-costeaGray py-1 h-10 box-border rounded-md text-t14 bg-white"
      >
        <option value="1">Nombre</option>
        <option value="2">Referencia</option>
      </select>
    </div>

    <!-- Fila 2: Input de búsqueda y botón de Excel -->
    <div class="flex flex-row gap-2 items-center">
      <!-- Input de búsqueda ocupa todo el ancho disponible -->
      <div class="flex-1 flex items-center bg-white h-10 box-border text-costeaGray text-t14 rounded-md">
        <i class="ri-search-line mx-2"></i>
        <input
          type="text"
          name="searchInput"
          id="searchInput"
          v-model="searchInput"
          class="w-full outline-none pr-2"
          placeholder="Buscar producto"
        />
      </div>

      <!-- Botón de Excel (o sus variantes) -->
      <div class="flex-shrink-0">
        <button
          @click="this.getDataForExcel"
          v-if="(this.rol_usuario === '1' || this.rol_usuario == '2') && !this.generatingExcel && !this.downloadExcel"
          class="flex justify-center items-center bg-costeaDarkGreen text-white font-costea text-sm w-12 h-10 transition cursor-pointer rounded-md hover:bg-green-600 relative buttonExcel"
        >
          <i class="ri-file-excel-2-fill text-xl"></i>
          <span class="bg-gray-600 text-white px-2 py-1 text-xs rounded-full absolute w-28 -bottom-12 right-0 opacity-0 buttonExcelToolTip">
            Exportar a Excel
          </span>
        </button>

        <p
          v-if="this.generatingExcel"
          class="flex justify-center items-center bg-costeaDarkGreen text-white font-costea text-sm w-auto h-10 transition cursor-pointer rounded-md hover:bg-green-600 relative buttonExcel"
        >
          <span class="text-white px-2 py-1 text-xs rounded-full">Generando...</span>
        </p>

        <vue-excel-xlsx
          v-if="this.downloadExcel"
          class="flex justify-center items-center bg-costeaPrimary text-white font-costea text-sm w-12 h-10 transition cursor-pointer rounded-md hover:bg-costeaHover relative buttonExcel"
          :data="this.columnasExcel[0]"
          :columns="this.columnasExcel[1]"
          :file-name="'Productos'"
          :file-type="'xlsx'"
          :sheet-name="'Productos'"
          @click="this.getDataForExcel"
        >
          <i class="ri-download-cloud-2-line text-xl"></i>
          <span class="bg-gray-600 text-white px-2 py-1 text-xs rounded-full absolute w-28 -bottom-12 right-0 opacity-0 buttonExcelToolTip">
            Descargar Excel
          </span>
        </vue-excel-xlsx>
      </div>
    </div>

    <!-- Fila 3: Paginación -->
    <div class="flex flex-col gap-2">
      <p class="text-costeaGray text-t14">
        <span class="text-costeaBlack font-medium">{{ page }}</span> de
        <span>{{ getPageNumber() }}</span>
      </p>
      <div class="flex flex-row gap-2">
        <button
          class="w-10 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray opacity-50"
          @click="page--, getPageNumber()"
          v-if="page != 1"
        >
          <i class="ri-arrow-left-line"></i>
        </button>
        <button
          class="w-10 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray"
          @click="page++, getPageNumber()"
          v-show="page < getPageNumber()"
        >
          <i class="ri-arrow-right-line"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Layout md y lg: se mantiene el layout original -->
  <div class="hidden md:flex flex-row justify-end flex-wrap gap-5 ">
    <!-- Se muestra el mismo contenido que tenías inicialmente -->
    <!-- <h1 class="font-costea text-h24 font-medium text-costeaBlack mb-4 md:mb-0">
      Productos
    </h1> -->

    <div class="flex flex-row flex-wrap gap-5">
      <div class="flex flex-row justify-center items-center gap-5">
        <select v-model="filtroOrden" class="text-costeaGray py-1 h-10 box-border rounded-md text-t14">
          <option value="0">Ordenar por:</option>
          <option value="1">P. venta de menor a mayor</option>
          <option value="2">P. venta de mayor a menor</option>
          <option value="3">Costo de menor a mayor</option>
          <option value="4">Costo de mayor a menor</option>
        </select>
      

      <div class="flex flex-row bg-white items-center justify-center w-36 h-10 box-border text-costeaGray text-t14 rounded-md">
        <select class="w-full" v-model="typeSearch">
          <option value="1">Nombre</option>
          <option value="2">Referencia</option>
        </select>
      </div>

      <div class="flex flex-row bg-white items-center justify-center w-48 h-10 box-border text-costeaGray text-t14 rounded-md">
        <i class="ri-search-line mx-2"></i>
        <input
          type="text"
          name="searchInput"
          id="searchInput"
          v-model="searchInput"
          class="w-40 outline-none pr-2"
          placeholder="Buscar producto"
        />
      </div>

      <p class="text-costeaGray ml-6 mr-3 text-t14  items-center flex gap-1">
        <span class="text-costeaBlack font-medium">{{ page }}</span> de <span>{{ getPageNumber() }}</span>
      </p>

      <div class="flex flex-row h-full">
        <button class="w-10 mr-1 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray opacity-50"
          @click="page--, getPageNumber()" v-if="page != 1">
          <i class="ri-arrow-left-line"></i>
        </button>
        <button class="w-10 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray"
          @click="page++, getPageNumber()" v-show="page < getPageNumber()">
          <i class="ri-arrow-right-line"></i>
        </button>
      </div>

      <button @click="this.getDataForExcel" v-if="(this.rol_usuario === '1' || this.rol_usuario == '2') && !this.generatingExcel && !this.downloadExcel"
        class="flex justify-center items-center bg-costeaDarkGreen text-white font-costea text-sm w-12 h-10 ml-3 transition cursor-pointer rounded-md hover:bg-green-600 relative buttonExcel">
        <i class="ri-file-excel-2-fill text-xl"></i>
        <span class="bg-gray-600 text-white px-2 py-1 text-xs rounded-full absolute w-28 -bottom-12 right-0 opacity-0 buttonExcelToolTip">
          Exportar a Excel
        </span>
      </button>

      <p v-if="this.generatingExcel"
        class="flex justify-center items-center bg-costeaDarkGreen text-white font-costea text-sm w-auto h-10 ml-3 transition cursor-pointer rounded-md hover:bg-green-600 relative buttonExcel">
        <span class="text-white px-2 py-1 text-xs rounded-full w-auto">Generando...</span>
      </p>

      <vue-excel-xlsx v-if="this.downloadExcel"
        class="flex justify-center items-center bg-costeaPrimary text-white font-costea text-sm w-12 h-10 ml-3 transition cursor-pointer rounded-md hover:bg-costeaHover relative buttonExcel"
        :data="this.columnasExcel[0]" :columns="this.columnasExcel[1]" :file-name="'Productos'" :file-type="'xlsx'" :sheet-name="'Productos'" @click="this.getDataForExcel">
        <i class="ri-download-cloud-2-line text-xl"></i>
        <span class="bg-gray-600 text-white px-2 py-1 text-xs rounded-full absolute w-28 -bottom-12 right-0 opacity-0 buttonExcelToolTip">
          Descargar Excel
        </span>
      </vue-excel-xlsx>
    </div>
    </div>
  </div>
</div>


    <div class="grid grid-cols-12 gap-2 pb-10">
      <div class="col-start-1 col-end-13 grid grid-cols-1 gap-6 md:grid-cols-3 xl:grid-cols-4 sm:grid-cols-2">
        <div v-for="product in displayedProducts" :key="product.index"
    class="rounded-md overflow-hidden flex flex-col items-center justify-start bg-white">
    <div class="relative w-full h-36" :style="`background-repeat: no-repeat; background-size: contain; background-position:center center; ${showImage(product.picture)}`">
        <!-- Badge para el MC -->
        <span v-if="product.precio_venta_actual && product.costo_total"
            class="flex flex-row absolute bg-costeaDarkYellow text-white w-auto right-2 top-2 text-t14 p-2 rounded-md">
            <span>
                MC: {{
                    product.precio_venta_actual == 0 || product.costo_total == 0
                    ? '0.00%'
                    : (
                        !isNaN(product.precio_venta_actual - product.costo_total)
                            ? (
                                ((product.precio_venta_actual - product.costo_total) / product.precio_venta_actual) * 100
                        ).toFixed(2)
                        : '0.00%'
                    )
                }}%
            </span>
        </span>
    </div>
          <div class="text-t12 leading-5 text-costeaGray px-5 py-3 border-b-2 border-costeaContainer w-11/12">
            <div>


            </div>
            <div v-if="loadingProducto" class="">
              <h4 class="skeleton font-medium text-t14 pb-2">
                {{ product.nombre }}
              </h4>
              <p class="">

                <span class="skeleton font-medium">Referencia:</span>
              </p>
              <p>

                <span class="skeleton font-medium">Codigo de barras:</span>
              </p>
              <p>

                <span class="skeleton font-medium">Categoría:</span>
              </p>
              <p>

                <span class="skeleton font-medium">Precio de venta (COP): $</span>
              </p>
              <p>

                <span class="skeleton font-medium">Costo Total (COP): $</span>
              </p>
              <p>

                <span class="skeleton font-medium">Utilidad (COP): $</span>
              </p>
              <p>

                <span class="skeleton font-medium">MC: </span>
              </p>
            </div>
            <div v-else>
              <h4 class="text-costeaBlack font-medium text-t14 pb-2">
                {{ product.nombre }}
              </h4>

              <p>
                Referencia:
                <span class="text-costeaBlack font-medium">{{
                  product.referencia
                }}</span>
              </p>
              <p>
                Codigo de barras:
                <span class="text-costeaBlack font-medium">{{
                  product.codigo_barras
                }}</span>
              </p>
              <p>
                Categoría:
                <span class="text-costeaBlack font-medium">{{ product.categoria_nombre }}</span>
              </p>
              <p>
                Precio de venta (COP): $
                <span class="text-costeaBlack font-medium">{{
                  interNumberFormat(product.precio_venta_actual)
                }}</span>
              </p>
              <!-- <p>
                Costo Total (COP): $
                <span class="text-costeaBlack font-medium">{{
                  interNumberFormat(calcularCostoTotal(product))
                }}</span>
              </p> -->
              <p v-if="rol_usuario !== '3'">
                Costo Total (COP): $
                <span class="text-costeaBlack font-medium">{{ interNumberFormat(parseFloat(product.costo_total))
                  }}</span>
              </p>
              <!-- <p v-if="rol_usuario !== '3'">
                Costo Total (COP): $
                <span class="text-costeaBlack font-medium">{{ 
                
                interNumberFormat(calcManoObra(product.id)+calcMateriaPrima(product.id)+calcCif(product))
                }}</span>
              </p> -->
              <!-- <p>
                Mano de obra (COP): $
                <span class="text-costeaBlack font-medium">{{
                  product.costo_mano_obra
                }}</span>
              </p> -->
              <!-- <p>
                materia prima (COP): $
                <span class="text-costeaBlack font-medium">{{
                  calcMateriaPrima(product.id)
                }}</span>
              </p> -->
              <!-- <p>
                Costo Cif$
                <span class="text-costeaBlack font-medium">{{
                  calcCif(product)
                }}</span>
              </p> -->
              <p v-if="rol_usuario !== '3'">
                Utilidad Bruta (COP): $
                <span class="text-costeaBlack font-medium">{{
                  product.precio_venta_actual == 0 ? 0 : (!isNaN(
                    product.precio_venta_actual -
                    product.costo_total
                  ) ?
                    interNumberFormat(
                      product.precio_venta_actual -
                      product.costo_total
                    ) : 0)
                }}</span>
              </p>
              <!-- <p>
                Margen de Contribución (MC): $
                <span class="text-costeaBlack font-medium">{{
                  product.precio_venta_actual == 0 || product.precio_venta_actual == 0
                    ? '0.00%'
                    : (
                      !isNaN(product.precio_venta_actual - product.costo_total)
                        ? (
                          ((product.precio_venta_actual - product.costo_total) / product.precio_venta_actual) * 100
                  ).toFixed(2)
                  : 0
                  )
                  }}%</span>
              </p> -->
            </div>

          </div>
          <div class="flex flex-row w-full justify-end mt-auto px-5 py-3 text-t14">
            <button v-if="rol_usuario != 3" @click="showModalDelete(product.nombre, product.id)"
              class="flex items-center justify-center rounded-full bg-gray-100 text-costeaGray hover:bg-costeaSalmonDisabled hover:text-costeaSalmon w-8 h-8">
              <i class="ri-delete-bin-6-line"></i>
            </button>
            <button v-if="rol_usuario != 3" @click="showModalClone(product.nombre, product.id)"
              class="flex items-center justify-center rounded-full bg-gray-100 text-costeaGray hover:bg-costeaSkyBlueDisabled hover:text-costeaSkyBlue w-8 h-8 ml-2">
              <i class="ri-file-copy-fill"></i>
            </button>
            <router-link :to="{ name: 'productDetail', query: { paginado: page }, params: { id: product.id } }">
              <button
                class="flex items-center justify-center rounded-full text-costeaGray bg-gray-100 hover:text-costeaPrimary hover:bg-costeaPrimaryDisabled w-8 h-8 ml-2">
                <i class="ri-eye-fill"></i>
              </button>
            </router-link>
          </div>
        </div>
      </div>
      <!-- /modal -->
    </div>
    <transition name="fade">
      <component :productoOld="deleteName" :productoId="deleteId" v-show="this.modalDelete" :is="this.delete"
        @closeModalDelete="handleDeleteCloseModal" @reloadData="reloadData" />
    </transition>
    <transition name="fade">
      <component :productoOld="cloneName" :productoId="cloneId" v-show="this.modalClone" :is="this.clone"
        @closeModalClone="handleCloneCloseModal" @reloadData="reloadData" />
    </transition>
    <transition name="page">
      <component :is="Add" @closeModalAdd="handleAddCloseModal" @reloadData="reloadData" />
    </transition>
    <buttonAdd @showModal="handleAddOpenModal" />
  </div>
</template>

<script>
import buttonAdd from "@/components/elements/ButtonAdd.vue";
import componentAdd from "@/components/productos/AddProducts.vue";
import productDelete from "@/components/productos/DeleteProducts.vue";
import productClone from '@/components/productos/CloneProducts.vue';
import axios from "axios";
import { mapState } from "vuex";
/*import ComponenteMensaje from '@/components/componentes/ComponenteMensaje.vue'*/
export default {
  name: "Productos",
  components: {
    /* ComponenteMensaje */
    buttonAdd,
    componentAdd,
    productDelete,
    productClone,
  },
  data: function () {
    return {
      nums: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      ventana: false,
      loadingProducto: true,
      ventanaactu: false,
      cop: false,
      usd: false,
      mensaje: false,
      accion: "Null",
      existencia: false,
      sin_existencia: true,
      detalle: true,
      rol_usuario: localStorage.getItem("rol_usuario"),
      productsForExcel: [],


      modalAdd: false,
      modalEdit: false,
      modalDelete: false,
      modalClone: false,

      deleteName: "",
      deleteId: "",
      cloneModal: "",
      cloneId: '',
      cloneName: '',

      modalActive: false,
      selected: "modal",

      productos: [],

      page: this.$route.query.paginado ? this.$route.query.paginado : 1,
      pages: [],
      elementsPerPage: 8,
      secretWord: localStorage.getItem("secret-word"),
      category: [],

      searchInput: "",
      typeSearch: "1",
      costosCif: [],
      componentesPrecio: [],
      componentes: [],
      productoComp: [],
      manoObraDirecta: [],
      generatingExcel: false,
      showDownload: false,
      filtroOrden: '0',
      downloadExcel: false,
      columnasExcel: [],
      loading: true
    };
  }, mounted() {
    setTimeout(() => {
      this.loadingProducto = false
    }, 3500);
  },
  computed: {
    ...mapState(["costea"]),
    Add() {
      if (this.modalAdd === true) {
        return "componentAdd";
      } else {
        return "";
      }
    },
    sumaCostoCif() {
      let sumaCosto = 0;
      /*for(let i=0; i<this.cifProducto.length; i++){
          let costoHora = Number(this.cifProducto[i].costo_mensual )
          sumaCosto += costoHora
        }*/
      for (let i = 0; i < this.costosCif.length; i++) {
        let costoHora = Number(this.costosCif[i].costo_mensual);
        sumaCosto += costoHora;
      }
      return Number(sumaCosto);
    },
    delete() {
      if (this.modalDelete === true) {
        return "productDelete";
      } else {
        return "";
      }
    },
    clone() {
      if (this.modalClone === true) {
        return "productClone";
      } else {
        return "";
      }
    },
    displayedProducts() {
      if (this.searchInput === "" && this.filtroOrden === "") {
        return this.paginate(this.productos);
      }
      if (this.searchInput !== "" && this.filtroOrden === "") {
        return this.paginate(this.findsearchInput);
      }
      if (this.filtroOrden !== "" && this.searchInput === "") {
        return this.paginate(this.ordenar);
      } else {
        return this.paginate(this.findsearchInput);
      }
    },

    findsearchInput() {
      let productos = "";
      if (this.typeSearch === "1") {
        productos = this.productos.filter((product) => {
          return product.nombre
            .toLowerCase()
            .includes(this.searchInput.toLowerCase());
        });
      }
      if (this.typeSearch === "2") {
        productos = this.productos.filter((product) => {
          return product.referencia
            .toLowerCase()
            .includes(this.searchInput.toLowerCase());
        });
      }
      return productos;
    },
    ordenar() {
      let data = this.productos;
      if (this.filtroOrden === "0") {
        data.sort((a, b) => a.id - b.id);
      }
      if (this.filtroOrden === "1") {
        data.sort((a, b) => a.precio_venta_actual - b.precio_venta_actual);
      }
      if (this.filtroOrden === "2") {
        data.sort((a, b) => b.precio_venta_actual - a.precio_venta_actual);
      }
      if (this.filtroOrden === "3") {
        data.sort((a, b) => {
          let calculo = a.costo_total - b.costo_total;
          return isNaN(calculo) ? 0 : calculo;
        });
      }
      if (this.filtroOrden === "4") {
        data.sort((a, b) => {
          let calculo = b.costo_total - a.costo_total;
          return isNaN(calculo) ? 0 : calculo;
        });
      }
      return data;
    },
  },
  methods: {
    JsonToXlsx() {
      // let productos = this.productsForExcel;
      let productos = this.productos
      let productosJson = [];
      productos.forEach(product => {
        let materiaPrima = product.costo_materia_prima;
        // let materiaPrima= this.calcMateriaPrima(product.id)
        let manoObra = product.costo_mano_obra;

        let costoCif = product.costo_cif;
        // let sumCostoCif = ((this.sumaCostoCif / product.horas_hombre) * product.tiempo_standar)

        let producto = {
          'Referencia': product.referencia,
          'Nombre del producto': product.nombre,
          'Categoría': product.categoria_nombre,
          'Precio de venta': (product.precio_venta_actual * 1),
          'Costo Materiales Directos': (materiaPrima * 1),
          'Costo Mano de Obra': (manoObra * 1),
          //REVISAR
          'Costos Indirectos de Fabricación': !isNaN(costoCif) ? (costoCif * 1) : 0,
          'Costo Total': !isNaN(product.costo_total) ? (product.costo_total * 1) : 0,
          'Utilidad Bruta': product.precio_venta_actual != 0 ? ((product.precio_venta_actual - product.costo_total) * 1) : 0,
        };
        productosJson.push(producto)
      })

      let columns = [
        {
          label: "Referencia",
          field: "Referencia",
        },
        {
          label: "Nombre del producto",
          field: "Nombre del producto",
        },
        {
          label: "Categoría",
          field: "Categoría",
        },
        {
          label: "Precio de venta",
          field: "Precio de venta",
        },
        {
          label: "Costo Materiales Directos",
          field: "Costo Materiales Directos",
        },
        {
          label: "Costo Mano de Obra",
          field: "Costo Mano de Obra",
        },
        {
          label: "Costos Indirectos de Fabricación",
          field: "Costos Indirectos de Fabricación",
        },
        {
          label: "Costo Total",
          field: "Costo Total",
        },
        {
          label: "Utilidad Bruta",
          field: "Utilidad Bruta",
        },
      ]
      this.generatingExcel = false;
      this.downloadExcel = true
      this.columnasExcel = [productosJson, columns];
    },

    // async getDataForExcel() {
    //   this.downloadExcel = false;
    //   this.generatingExcel = true;

    //   try {
    //     // Obtener los IDs de los productos que queremos exportar
    //     let productIds = this.productos.map(producto => producto.id);

    //     // Realizar la petición POST con los IDs en el cuerpo     

    //     const response = await axios.post(
    //       `${this.costea.protocol}${localStorage.getItem("secret-word")}${this.costea.baseURL}productos/costos`,
    //       {
    //         ids: productIds
    //       },
    //       {
    //         headers: {
    //           'Content-Type': 'application/json'
    //         }
    //       }
    //     );


    //     // Verificar si la respuesta fue exitosa
    //     if (response.data.status === 'Success') {
    //       this.productsForExcel = response.data.Productos;
    //       // Continuar con la lógica de exportación
    //       this.JsonToXlsx();
    //     } else {
    //       // Manejar el caso de error
    //       console.error("Failed to get product costs data: " + response.data.message);
    //     }
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     this.generatingExcel = false;
    //   }
    // },
    
    async getDataForExcel() {
      this.downloadExcel = false
      this.generatingExcel = true;
      // await this.getComponentes()    

      // try {
      //   // Get the IDs of the products that we want to export
      //   let productIds = this.productos.map(producto => producto.id).join(',');
      //   const response = await axios.get(`${this.costea.protocol}${localStorage.getItem("secret-word")}${this.costea.baseURL}productos/costos/${productIds}`);
      //   if (response.data.status == 'Success') {
      //     this.productsForExcel = response.data.Productos;
      //     // console.log(this.productos)
      //     // Now you have the product data including the costs, so you can continue with your export logic
      //     // ...
      //     this.JsonToXlsx()

      //   } else {
      //     // Handle the error case
      //     console.error("Failed to get product costs data: " + response.data.message);
      //   }
      // } catch (error) {
      //   console.error(error);
      // }

      try {
        const productIds = this.productos.map(producto => producto.id); // como array, no join

        const response = await axios.post(
          `${this.costea.protocol}${localStorage.getItem("secret-word")}${this.costea.baseURL}productos/costos`,
          { ids: productIds }
        );

        if (response.data.status === 'Success') {
          this.productsForExcel = response.data.Productos;
          this.JsonToXlsx();
        } else {
          console.error("Failed to get product costs data: " + response.data.message);
        }
      } catch (error) {
        console.error("Error en la petición:", error);
      }


    },


    getProduct(productoID) {
      return this.productos.find(prod => prod.id == productoID);
    },

    interNumberFormat(number) {
      if (!number) {
        return 0;
      }

      let interNF = new Intl.NumberFormat("es-CO");
      let numberDecimals = parseFloat(number).toFixed(2);

      return isNaN(number) ? number : interNF.format(numberDecimals);
    },

    calcManoObra(productoID) {
      let producto = this.getProduct(productoID);

      return producto.modirectas.reduce((suma, modirecta) => {
        let mod = this.manoObraDirecta.find(mod => mod.id == modirecta.mano_obra_directa_id);

        if (mod) {
          let costoHora = Number(mod.costo_hora_hombre);
          let tiempoStandar = Number(mod.tiempo_standar);

          suma += costoHora * tiempoStandar;
        }

        return suma;
      }, 0);
    },

    calcMateriaPrima(productoID) {
      let producto = this.getProduct(productoID);

      return producto.componentes.reduce((suma, componente) => {
        let costoUnitario = componente.tipo_materia_prima == "Nacional" ? componente.costo_unitario : componente.costo_unitario * componente.tasa_de_cambio;
        suma += Number(costoUnitario) * Number(componente.cantidadVinculada);

        return suma;
      }, 0);
    },


    calcularCostoTotal(producto) {
      // Realizar el cálculo del costo total utilizando la lógica actual
      // y devolver el valor calculado
      return (
        producto.costo_total ||
        (this.calcMateriaPrima(producto.id) +
          this.calcManoObra(producto.id) +
          (this.sumaCostoCif / producto.horas_hombre) *
          producto.tiempo_standar)
      );
    },


    // getCatName(id) {
    //   let categoryName;
    //   this.category.find((el) => {
    //     if (el.id == id) {
    //       categoryName = el.name;
    //     }
    //   });
    //   return categoryName;
    // },
    // getUrl(path) {
    //   return `${this.costea.protocol}${localStorage.getItem("secret-word")}${this.costea.baseURL}${path}`;
    // },

    async getMod() {
      try {
        const response = await axios.get(this.getUrl('mod'));
        this.manoObraDirecta = response.data;
        this.getCIF();
        console.log("GetMod")
      } catch (error) {
        console.log(error);
      }
    },

    async getCIF() {
      try {
        const response = await axios.get(this.getUrl('cif'));
        this.costosCif = response.data;
        this.showDownload = true;
        if (this.generatingExcel) {
          this.generatingExcel = false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    calcCif(product) {
      let sumaCosto = 0
      let total = 0
      for (let i = 0; i < this.costosCif.length; i++) {
        let costoHora = Number(this.costosCif[i].costo_mensual)
        sumaCosto += costoHora
      }
      total = ((sumaCosto / product.horas_hombre) * product.tiempo_standar).toFixed(2)
      return Number(total)
    },
    //   async getComponentes() {
    //   try {
    //     const response = await axios.get(`${this.costea.protocol}${localStorage.getItem("secret-word")}${this.costea.baseURL}componentes`);
    //     this.componentes = response.data;
    //     await this.getMod();
    //     // this.filterComponents();
    //     if (!this.generatingExcel) {
    //       this.generatingExcel = false;
    //     }
    //     //console.log(this.componentes)
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },


    showImage(imagen) {
      if (imagen != null) {
        let imageFromServer =
          this.costea.protocol +
          this.secretWord +
          ".backend.costea.com.co/" +
          // ".tst.costea.com.co/" +
          imagen;
        return `background-color: #E6E8ED; background-image: url(' ${imageFromServer} ');`;
      } else {
        return ` background-color: #056CF2; background-image: url('/img/costea-placeholder.png');`;
      }
    },
    //  getCalcMOD (){
    //    return new Promise((resolve, reject) => {
    //     axios.get(
    //         `${this.costea.protocol}${localStorage.getItem("secret-word")}${
    //           this.costea.baseURL
    //         }calcularMOD`
    //       )
    //       .then((respuesta) => {
    //         console.log("Calc MOD ",respuesta)
    //       }).catch((error) => {
    //             console.log(error);
    //             reject();
    //       });
    //   })
    // },
    async getProductos() {
      try {
        const respuesta = await axios.get(`${this.costea.protocol}${localStorage.getItem("secret-word")}${this.costea.baseURL}productos`);

        if (respuesta.data.status == false) {
          this.$router.push("/login");
        }

        this.productos = respuesta.data.Productos;
        this.pages = [];
        this.setPages();
        // await this.getComponentes();
        this.loading = false;

        // const res = await axios.get(`${this.costea.protocol}${localStorage.getItem("secret-word")}${this.costea.baseURL}categories`);
        // // alert(res)
        // this.category = res.data;

      } catch (error) {
        console.log(error);
      }
    },



    reloadData(value) {
      if (value === true) {
        this.getProductos();
        value = false;
      } else {
        console.log("Ocurrio un error");
      }
    },

    handleAddOpenModal(value) {
      this.modalAdd = value;
    },
    handleAddCloseModal(value) {
      this.modalAdd = value;
    },
    handleDeleteCloseModal(value) {
      this.modalDelete = value;
    },
    handleCloneCloseModal(value) {
      this.modalClone = value;
    },
    showModalDelete(name, id) {
      if (this.modalDelete === false) {
        this.modalDelete = true;
        this.deleteName = name;
        this.deleteId = id;
      } else {
        this.modalDelete = false;
      }
    },
    showModalClone(name, id) {
      if (this.modalClone === false) {
        this.modalClone = true;
        this.cloneName = name;
        this.cloneId = id;
      } else {
        this.modalClone = false;
      }
    },


    //Paginado
    setPages() {
      let numberOfPages = Math.ceil(
        this.productos.length / this.elementsPerPage
      );
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(obj) {
      let page = this.page;
      let perPage = this.elementsPerPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return obj.slice(from, to);
    },
    getPageNumber() {
      return this.pages.length;
    },
  },
  beforeCreate() {
    if (localStorage.getItem("token")) {
      return true;
    } else {
      this.$router.push("/login");
    }
  },
  beforeMount() {
    // this.getCalcMOD()
    if (localStorage.getItem("token")) {
      this.getProductos();
    } else {
      this.$router.push("/login");
    }
  },
};
</script>

<style>
.flex-responsive {
  flex-direction: row;
}

@media (max-width:768px) {
  .flex-responsive {
    flex-direction: column;
    gap: 5px;
  }
}



/* Estilos del loader */
.loader {
  border: 4px solid #f3f3f3;
  /* Gray border */
  border-top: 4px solid #3498db;
  /* Blue border */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.skeleton {
  position: relative;
  width: 100%;
  /* Ancho del skeleton */
  height: auto;
  /* Altura del skeleton */
  overflow: hidden;
  /* Oculta el desbordamiento del pseudo-elemento */
  color: transparent
}

.skeleton::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: transparent;
  background-color: #f2f2f2;
  /* Color de fondo del skeleton */
  animation: skeleton-loading 1s infinite ease-in-out;
  /* Animación del skeleton */
}

@keyframes skeleton-loading {
  0% {
    opacity: 0.7;
    /* Opacidad inicial del skeleton */
  }

  50% {
    opacity: 0.4;
    /* Opacidad intermedia del skeleton */
  }

  100% {
    opacity: 0.7;
    /* Opacidad final del skeleton */
  }
}

.z-100 {
  z-index: 100;
}

.costeaGreenGradient {
  background: linear-gradient(to left, #1db966, #2ae0af);
}

.costeaMaxWidth {
  max-width: 380px;
}

.buttonExcel:hover .buttonExcelToolTip {
  transition: 0.3s ease all;
  transform: translateY(-22px);
  opacity: 100;
}
</style>
